/**
 * True when the primary pointer is coarse (a finger), per the
 * `(pointer: coarse)` media feature. This is the right knob for target size
 * and for "is there a hover / modifier key to lean on" — an iPad in landscape
 * is wider than the 768px mobile breakpoint `useIsMobile` reads, yet has no
 * hover and no Alt. Viewport width and pointer kind are independent axes.
 */
import { useIsMobile } from "./useIsMobile.js";

export function usePointerCoarse(): boolean {
  return useIsMobile("(pointer: coarse)");
}
